import { render, staticRenderFns } from "./shortVideoCommerce.vue?vue&type=template&id=2bc488f8&scoped=true"
import script from "./shortVideoCommerce.vue?vue&type=script&lang=js"
export * from "./shortVideoCommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc488f8",
  null
  
)

export default component.exports